/*  MUI  */
import { Skeleton, TableCell, TableRow } from '@mui/material';

/*  React  */
import React from 'react';

/* Internal Components */
import { useManagedTableV2Context } from '../ManagedTableV2ContextProvider';

export const ManagedTableSkeletonRowsV2 = ({ rowHeight }) => {
    const { colSpan, rowsPerPage } = useManagedTableV2Context();
    const skeletonCells = [...Array(colSpan).keys()].map((index) => (
        <TableCell key={`skeleton_cell_colSpan_${index}`}>
            <Skeleton
                height={rowHeight ? rowHeight - 12 : '32px'}
                animation="wave"
            />
        </TableCell>
    ));

    const skeletonBody = [...Array(rowsPerPage).keys()].map((index) => (
        <TableRow
            sx={{
                backgroundColor: 'table.rowBackground',
                minHeight: rowHeight || '32px',
                overflow: 'hidden'
            }}
            key={`skeleton_cell_row_${index}`}
        >
            {skeletonCells}
        </TableRow>
    ));

    return skeletonBody;
};
